import { ReactNode } from 'react';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import { AppPermissions } from '../../../types';
import { PermissionsProvider } from '../../Permissions';
import { DivisionCountryFilter } from '../../filters';
import { FilterPanel, StatusChip } from '../../Visual';
import {
  accountingParametersChangeCountry,
  accountingParametersCountrySelector,
} from '../../../state';

export interface AccountingEntriesFiltersProps {
  actions: ReactNode;
}

const resourcePermissions = [AppPermissions.ACCOUNTING_PARAMETERS_QUERY];

const AccountingEntriesFilters = ({ actions }: AccountingEntriesFiltersProps) => {
  const { t } = useTranslation();
  return (
    <PermissionsProvider resourcePermissions={resourcePermissions}>
      <FilterPanel
        subtitle={t('accountingParameters.filters.subtitle')}
        actions={<StatusChip status="success" label={t('filters.status.ready')} />}
      >
        <Grid container spacing={3} alignItems="flex-end">
          <Grid item xs={12} md={4} lg={2} xl={2}>
            <DivisionCountryFilter
              valueSelector={accountingParametersCountrySelector}
              actionChange={accountingParametersChangeCountry}
              fullWidth
              disableClearable
            />
          </Grid>
          <Grid item xs={12} md lg xl>
            {actions}
          </Grid>
        </Grid>
      </FilterPanel>
    </PermissionsProvider>
  );
};

export default AccountingEntriesFilters;
